import React from 'react';
import { FishByType } from '../../core/constants/fishImagesArray';

export const HistoryItem = ({ roundResult, index, additionalParams }) => {
  const parsedResultType =
    roundResult?.resultType > 9 && roundResult?.resultType < 15
      ? roundResult?.resultType - 1
      : roundResult?.resultType > 15
      ? roundResult?.resultType - 2
      : roundResult?.resultType;

  return (
    <li
      className={`fs-gathered-fish-list-el ${
        // eslint-disable-next-line no-nested-ternary
        additionalParams
          ? additionalParams.betStep <= index && additionalParams.cashOutStep > index
            ? 'active'
            : ''
          : ''
      }`}
    >
      <div className='fs-gathered-fish-image-wrapper'>
        {(roundResult?.resultType || roundResult?.resultType === 0) && (
          <img className='gatheredFish' src={FishByType[parsedResultType]} alt='' />
        )}
      </div>
      <div className='gatheredFishMultiplierContainer'>
        <span className='gatheredFishMultiplier'>x{roundResult?.odd}</span>
      </div>
    </li>
  );
};
